import React from 'react';
import type { VideoBlockContent } from '../../../types/popup.types';

interface VideoBlockProps {
  content: VideoBlockContent;
}

const VideoBlock: React.FC<VideoBlockProps> = ({ content }) => {
  const { url, alt, width, link, borderRadius } = content;

  // URL boş ise render etme
  if (!url || url.trim() === '') {
    return null;
  }

  const videoElement = (
    <video
      src={url}
      aria-label={alt || undefined}
      className="img-fluid"
      style={{
        width: width || '100%',
        borderRadius: `${borderRadius || 0}px`,
        maxWidth: '100%',
      }}
      controls={!link}
      preload="metadata"
    />
  );

  const videoContent = link ? (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {videoElement}
    </a>
  ) : (
    videoElement
  );

  return <div style={{ marginBottom: '16px' }}>{videoContent}</div>;
};

export default VideoBlock;
